import type * as Types from "../../graphql/graphql-generated.types";

import { gql } from "@apollo/client";
import * as Apollo from "@apollo/client";
const defaultOptions = {} as const;
export type GetAppointmentSchedulesQueryVariables = Types.Exact<{
  from: Types.Scalars["Date"]["input"];
  to: Types.Scalars["Date"]["input"];
  timeZone: Types.Scalars["String"]["input"];
}>;

export type GetAppointmentSchedulesQuery = {
  __typename?: "Query";
  getAppointmentSchedules: Array<{
    __typename?: "AppointmentSchedule";
    uuid: string;
    startTime: string;
    endTime: string;
    description: string | null;
    eventStatus: Types.ScheduleStatus;
    appointmentType: { __typename?: "AppointmentType"; color: string };
    user: { __typename?: "User"; firstName: string; lastName: string };
    staff: {
      __typename?: "User";
      uuid: string;
      firstName: string;
      lastName: string;
    } | null;
  }>;
};

export type AppointmentScheduleToCalendarFragment = {
  __typename?: "AppointmentSchedule";
  uuid: string;
  startTime: string;
  endTime: string;
  description: string | null;
  eventStatus: Types.ScheduleStatus;
  appointmentType: { __typename?: "AppointmentType"; color: string };
  user: { __typename?: "User"; firstName: string; lastName: string };
  staff: {
    __typename?: "User";
    uuid: string;
    firstName: string;
    lastName: string;
  } | null;
};

export type GetCalendarItemsQueryVariables = Types.Exact<{
  getCalendarItemsInput: Types.GetCalendarItemsInput;
}>;

export type GetCalendarItemsQuery = {
  __typename?: "Query";
  getCalendarItems: Array<{
    __typename?: "Class";
    uuid: string;
    title: string;
    type: string;
    isAllDay: boolean;
    startDatetime: string;
    endDatetime: string;
    calendarItemType: {
      __typename?: "CalendarItemType";
      color: string | null;
    } | null;
    location: {
      __typename?: "CalendarItemLocation";
      uuid: string | null;
    } | null;
    mainCoach: {
      __typename?: "Profile";
      userUuid: string;
      firstName: string | null;
      lastName: string | null;
    } | null;
    assistantCoach: { __typename?: "Profile"; userUuid: string } | null;
  }>;
};

export type CalendarItemFragment = {
  __typename?: "Class";
  uuid: string;
  title: string;
  type: string;
  isAllDay: boolean;
  startDatetime: string;
  endDatetime: string;
  calendarItemType: {
    __typename?: "CalendarItemType";
    color: string | null;
  } | null;
  location: { __typename?: "CalendarItemLocation"; uuid: string | null } | null;
  mainCoach: {
    __typename?: "Profile";
    userUuid: string;
    firstName: string | null;
    lastName: string | null;
  } | null;
  assistantCoach: { __typename?: "Profile"; userUuid: string } | null;
};

export const AppointmentScheduleToCalendarFragmentDoc = gql`
  fragment AppointmentScheduleToCalendar on AppointmentSchedule {
    uuid
    startTime
    endTime
    description
    eventStatus
    appointmentType {
      color
    }
    user {
      firstName
      lastName
    }
    staff {
      uuid
      firstName
      lastName
    }
  }
`;
export const CalendarItemFragmentDoc = gql`
  fragment CalendarItem on Class {
    uuid
    title
    type
    isAllDay
    startDatetime
    endDatetime
    calendarItemType {
      color
    }
    location {
      uuid
    }
    mainCoach {
      userUuid
      firstName
      lastName
    }
    assistantCoach {
      userUuid
    }
  }
`;
export const GetAppointmentSchedulesDocument = gql`
  query GetAppointmentSchedules($from: Date!, $to: Date!, $timeZone: String!) {
    getAppointmentSchedules(from: $from, to: $to, timeZone: $timeZone) {
      ...AppointmentScheduleToCalendar
    }
  }
  ${AppointmentScheduleToCalendarFragmentDoc}
`;

/**
 * __useGetAppointmentSchedulesQuery__
 *
 * To run a query within a React component, call `useGetAppointmentSchedulesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentSchedulesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentSchedulesQuery({
 *   variables: {
 *      from: // value for 'from'
 *      to: // value for 'to'
 *      timeZone: // value for 'timeZone'
 *   },
 * });
 */
export function useGetAppointmentSchedulesQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetAppointmentSchedulesQuery,
    GetAppointmentSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    GetAppointmentSchedulesQuery,
    GetAppointmentSchedulesQueryVariables
  >(GetAppointmentSchedulesDocument, options);
}
export function useGetAppointmentSchedulesLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetAppointmentSchedulesQuery,
    GetAppointmentSchedulesQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetAppointmentSchedulesQuery,
    GetAppointmentSchedulesQueryVariables
  >(GetAppointmentSchedulesDocument, options);
}
export type GetAppointmentSchedulesQueryHookResult = ReturnType<
  typeof useGetAppointmentSchedulesQuery
>;
export type GetAppointmentSchedulesLazyQueryHookResult = ReturnType<
  typeof useGetAppointmentSchedulesLazyQuery
>;
export type GetAppointmentSchedulesQueryResult = Apollo.QueryResult<
  GetAppointmentSchedulesQuery,
  GetAppointmentSchedulesQueryVariables
>;
export const GetCalendarItemsDocument = gql`
  query GetCalendarItems($getCalendarItemsInput: GetCalendarItemsInput!) {
    getCalendarItems(getCalendarItemsInput: $getCalendarItemsInput) {
      ...CalendarItem
    }
  }
  ${CalendarItemFragmentDoc}
`;

/**
 * __useGetCalendarItemsQuery__
 *
 * To run a query within a React component, call `useGetCalendarItemsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetCalendarItemsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetCalendarItemsQuery({
 *   variables: {
 *      getCalendarItemsInput: // value for 'getCalendarItemsInput'
 *   },
 * });
 */
export function useGetCalendarItemsQuery(
  baseOptions: Apollo.QueryHookOptions<
    GetCalendarItemsQuery,
    GetCalendarItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<GetCalendarItemsQuery, GetCalendarItemsQueryVariables>(
    GetCalendarItemsDocument,
    options,
  );
}
export function useGetCalendarItemsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    GetCalendarItemsQuery,
    GetCalendarItemsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    GetCalendarItemsQuery,
    GetCalendarItemsQueryVariables
  >(GetCalendarItemsDocument, options);
}
export type GetCalendarItemsQueryHookResult = ReturnType<
  typeof useGetCalendarItemsQuery
>;
export type GetCalendarItemsLazyQueryHookResult = ReturnType<
  typeof useGetCalendarItemsLazyQuery
>;
export type GetCalendarItemsQueryResult = Apollo.QueryResult<
  GetCalendarItemsQuery,
  GetCalendarItemsQueryVariables
>;
